var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCookIslands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#071b65",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 9.77V12h4V9.77L12.54 12H15v-1.24L11.24 8H15V4h-2.74L15 2V0h-1.44L9.5 2.98V0h-4v2.8L1.75 0H0v1.9L2.99 4H0v4h3.76L0 10.76V12h2.46z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "m0 1 4.09 3h1.36L0 0zm0 11 5.45-4v1l-4.09 3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M8.5 12h-2V7H0V5h6.5V0h2v5H15v2H8.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M15 11.67 10 8v1l4.1 3h.9zM15 0h-.25L9.3 4h1.37L15 .82z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.91 7.27.67-.49h-.83L22.5 6l-.25.78h-.83l.67.49-.26.78.67-.48.67.48zm2.1.6.8-.17-.74-.33.08-.82-.55.61-.75-.33.41.71-.55.61.8-.17.42.71zm1.68 1.45.8.17-.54-.61.4-.72-.74.34-.56-.61.1.82-.76.34.8.16.1.82zm.94 1.97.67.48-.26-.78.66-.5-.82.01-.26-.78-.25.79h-.82l.67.48-.25.78zm.07 2.2.41.72.08-.82.81-.18-.75-.33.08-.82-.55.61-.75-.33.41.71-.55.62zm-.85 2 .08.83.41-.71.81.17-.55-.62.41-.7-.75.33-.55-.62.08.82-.75.34zm-1.6 1.55-.24.78.66-.48.67.48-.26-.78.66-.49h-.82l-.26-.78-.25.79h-.82zm-2.06.72-.55.62.8-.18.42.71.08-.82.8-.17-.75-.33.09-.82-.55.61-.75-.33zM20 7.87l-.8-.17.74-.33-.08-.82.55.61.75-.33-.41.71.55.61-.8-.17-.42.71zm-1.7 1.45-.8.17.54-.61-.4-.72.74.34.56-.61-.1.82.76.34-.8.16-.1.82zm-.94 1.97-.67.48.26-.78-.67-.5.83.01.26-.78.25.79h.82l-.67.48.25.78zm-.07 2.2-.41.72-.09-.82-.8-.18.75-.33-.08-.82.55.61.75-.33-.41.71.55.62zm.85 2-.08.83-.41-.71-.81.17.55-.62-.41-.7.75.33.55-.62-.08.82.75.34zm1.6 1.55.24.78-.66-.48-.67.48.26-.78-.66-.49h.82l.26-.78.25.79h.82zm2.06.72.55.62-.8-.18-.42.71-.08-.82-.8-.17.74-.33-.08-.82.55.61.75-.33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookIslands);
export default __webpack_public_path__ + "static/media/cook-islands.3d27bc9c3c02c830c331c752c1f7201b.svg";
export { ForwardRef as ReactComponent };